import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'; // Swiper 5.x

import SwiperClass from 'swiper';

var _getAwesomeSwiper = getAwesomeSwiper(SwiperClass),
    Swiper = _getAwesomeSwiper.Swiper,
    SwiperSlide = _getAwesomeSwiper.SwiperSlide,
    directive = _getAwesomeSwiper.directive,
    install = _getAwesomeSwiper.install,
    version = _getAwesomeSwiper.version;

export { Swiper, SwiperSlide, directive, install, version };